// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sideId: __t.u64().primaryKey().name("side_id"),
  campaignId: __t.u64().name("campaign_id"),
  side: __t.u8(),
  civ: __t.string(),
  capsCommitted: __t.u32().name("caps_committed"),
  capsAlive: __t.u32().name("caps_alive"),
  skirmCommitted: __t.u32().name("skirm_committed"),
  skirmAlive: __t.u32().name("skirm_alive"),
  skLost: __t.u32().name("sk_lost"),
  capLost: __t.u32().name("cap_lost"),
  points: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
